import { api } from 'utility';
import {
  getUsageRestrictionsUrl,
  getDelegationConsumptionUrl,
  getReceivedDeligationUrl,
  getDefaultDeligationUrl,
  getDelegationReceivedUrl,
  getCategoryInvociePayment
} from 'URLs';
export function putDefaultList(id) {
  return api.put(getDefaultDeligationUrl(id)).then((res) => res.data);
}

export function getAssignedDelegation(data, params) {
  return api.post(getReceivedDeligationUrl(), data, { params }).then((res) => res.data);
}

export function getUsageRestrictions(data, params) {
  return api.post(getUsageRestrictionsUrl(), data, { params }).then((res) => res.data);
}

export function getCategoryList(params) {
  return api.get(getCategoryInvociePayment(), { params }).then((res) => res.data);
}


export function getDelegationReport(params) {
  return api.get(getDelegationReceivedUrl(), { params }).then((res) => res.data);
}

export function getDelegationConsumption(data, params) {
  return api.post(getDelegationConsumptionUrl(), data, { params }).then((res) => res.data);
}

export default {
  getAssignedDelegation,
  getUsageRestrictions,
  getDelegationConsumption,
  putDefaultList,
  getDelegationReport,
  getCategoryList
};
